import React from 'react';
import styles from './css/index.module.css';
import { Input, Textarea } from '@fluentui/react-components';
import { CheckmarkCircleFilled } from '@fluentui/react-icons';
import { PatchProjectData } from '../../redux/projectDataSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { toast } from 'react-toastify';

const verifiedFromEnrichment = (fieldMeta, key) =>
    fieldMeta?.[key]?.source === 'custom' && fieldMeta?.[key]?.confidence === 'high';

const FieldLabel = ({ children, fieldMeta, metaKey }) => (
    <p className={`${styles.fieldLabel} d-flex align-items-center gap-1`}>
        {verifiedFromEnrichment(fieldMeta, metaKey) && (
            <CheckmarkCircleFilled style={{ color: '#107c10', flexShrink: 0 }} title="Verified from company enrichment" />
        )}
        {children}
    </p>
);
const AddOrganisationDetail = ({ setSelectedView, createdProjectData }) => {
    const dispatch = useDispatch();
    const { projectDetailButtonLoading, companyProfileFetchStatus } = useSelector(state => state.projectData);
    const fetchToastIdRef = React.useRef(null);
    const [formData, setFormData] = React.useState({
        sector: '',
        established_year: '',
        description: '',
        company_size: '',
    });
    const handleChange = e => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleSubmit = async () => {
        await dispatch(
            PatchProjectData({
                data: {
                    sector: formData?.sector,
                    established_year: formData?.established_year,
                    description: formData?.description,
                    company_size: formData?.company_size,
                    ...(createdProjectData?.companieshouse
                        ? { companieshouse: String(createdProjectData.companieshouse) }
                        : {}),
                },
                id: createdProjectData?.id,
            }),
        );

        setSelectedView('brandDetails');
    };

    React.useEffect(() => {
        if (createdProjectData) {
            setFormData({
                sector: createdProjectData?.sector,
                established_year: createdProjectData?.established_year,
                description: createdProjectData?.description,
                company_size: createdProjectData?.company_size,
            });
        }
    }, [createdProjectData]);

    React.useEffect(() => {
        if (companyProfileFetchStatus === 'pending') {
            if (!fetchToastIdRef.current) {
                fetchToastIdRef.current = toast.loading('Fetching company details', { position: 'top-right' });
            }
            return;
        }

        if (fetchToastIdRef.current) {
            toast.dismiss(fetchToastIdRef.current);
            fetchToastIdRef.current = null;
        }
    }, [companyProfileFetchStatus]);

    React.useEffect(
        () => () => {
            if (fetchToastIdRef.current) {
                toast.dismiss(fetchToastIdRef.current);
            }
        },
        [],
    );

    const fieldMeta = createdProjectData?._fieldMeta;

    return (
        <div className={styles.componentCard}>
            <h5 className={styles.componentTitle}>Confirm organisation details</h5>
            <div>
                <div className="mb-4">
                    <FieldLabel fieldMeta={fieldMeta} metaKey="sector">
                        Sector
                    </FieldLabel>
                    <Input placeholder="Add Company Sector" className={styles.inputField} value={formData?.sector} onChange={handleChange} name="sector" />
                </div>
                <div className="mb-4">
                    <FieldLabel fieldMeta={fieldMeta} metaKey="company_size">
                        Company size
                    </FieldLabel>
                    <Input className={styles.inputField} placeholder="1-1000" value={formData?.company_size} onChange={handleChange} name="company_size" />
                </div>
                <div className="mb-4">
                    <FieldLabel fieldMeta={fieldMeta} metaKey="description">
                        About the company
                    </FieldLabel>
                    <Textarea
                        placeholder="Add company description, services offered, etc."
                        rows={6}
                        className={styles.textareaField}
                        value={formData?.description}
                        onChange={handleChange}
                        name="description"
                    />
                </div>
                <div className="mb-4 w-50">
                    <FieldLabel fieldMeta={fieldMeta} metaKey="established_year">
                        Year of establishment
                    </FieldLabel>
                    <Input className={styles.inputField} value={formData?.established_year} onChange={handleChange} name="established_year" />
                </div>
                <button onClick={handleSubmit} className={styles.submitButton}>
                    Confirm {projectDetailButtonLoading && <AiOutlineLoading3Quarters className="ms-2 rotateLoader" />}
                </button>
            </div>
        </div>
    );
};

export default AddOrganisationDetail;
